<template>
  <div class="custom-el-wrapper">
    <div class="form-box custom-form-wrap">
      <el-form inline size="mini">
          <el-form-item label="" label-width="0">
              <el-input v-model="searchParams.task_no" placeholder="请输入检测编号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <button type="button" class="btn btn--primary" @click="handleSearch">查询</button>
            <button type="button" class="btn" @click="refresh">重置</button>
          </el-form-item>
      </el-form>
    </div>
    <div class="custom-table-wrap" >
      <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
              :header-cell-style="{ background: 'rgb(245, 240, 232)', color: '#606266' }" class="rc_table" row-key="id" >
      <el-table-column type="selection" align="center"  width="50"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
      <el-table-column label="检测编号" prop="task_no" align="center" show-overflow-tooltip class-name="rc-col-no" width="280">
      </el-table-column>
      <el-table-column label="违规关键词" prop="sku_name_abnormal_words" show-overflow-tooltip align="center" min-width="150" class-name="rc-col-red"></el-table-column>
      <el-table-column label="违规尺码" prop="sku_size_abnormal_words" show-overflow-tooltip align="center" min-width="150" class-name="rc-col-red"></el-table-column>
      <el-table-column label="分组" prop="group_names" width="200" show-overflow-tooltip align="center"></el-table-column>

      <el-table-column label="已检测/总数" align="center" width="150" show-overflow-tooltip>
        <template #default="{ row }">
          <span style="color: rgb(212, 169, 70);">{{row.product_pro_count_total}}/{{row.product_count_total}}</span>
        </template>
      </el-table-column>
      <el-table-column label="异常数量" prop="product_pro_abnormal_count_total" align="center" width="100" show-overflow-tooltip>
        <template #default="{ row }">
          <span :style="row.product_pro_abnormal_count_total>0?'color:rgb(200, 68, 60)':'color:rgb(212, 169, 70)'">{{row.product_pro_abnormal_count_total}}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column label="状态" prop="status" align="center"></el-table-column> -->
      <el-table-column align="center" label="状态" prop="status" width="100px">
        <template #default="{ row }">
          <el-tag size="small" type="warning" v-if="row.status == 1">待执行</el-tag>
          <el-tag size="small" type="primary" v-else-if="row.status == 2">执行中</el-tag>
          <el-tag size="small" type="success" v-else-if="row.status == 3">完成</el-tag>
          <el-tag size="small" type="danger" v-else>异常</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="180" prop="created_at" show-overflow-tooltip align="center">
        <template #default="{ row }">
          <span style="color: rgb(153, 153, 153);">{{row.created_at}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template #default="{ row }">
          <!-- <el-tag size="small" type="success">{{row.product_pro_count_total}}/{{row.product_count_total}}</el-tag> -->
          <button class="opt-btn opt-btn--blue" @click="view_info(row)">查看策略</button>
          <button  class="opt-btn opt-btn--red"  @click="view_abnormal(row)">查看异常</button>
        </template>
      </el-table-column>
    </el-table>


     <div class="rc-pager" v-if="page_data.total > 0">
      <!-- 左:总条数 + 每页条数 -->
      <div class="rc-pager__col rc-pager__col--left">
        <span class="rc-pager__total">共 <span class="rc-pager__num">{{ page_data.total }}</span> 条</span>
        <el-select size="mini" v-model="page_data.limit" @change="onPageSizeChange" style="width: 100px">
          <el-option v-for="item in pageSizeOptions" :key="item" :value="item" :label="`${item}条/页`"></el-option>
        </el-select>
      </div>
      <!-- 中:页码按钮组 -->
      <div class="rc-pager__col rc-pager__col--center custom-page-wrap">
        <el-pagination
          :total="page_data.total"
          :page-size="page_data.limit"
          :current-page="page_data.page"
          layout="prev, pager, next"
          small
          @current-change="onPageChange"
        />
      </div>
      <!-- 右:跳转 -->
      <div class="rc-pager__col rc-pager__col--right">
        <span class="rc-pager__jump">
          <span>前往</span>
          <input v-model.number="jumpInput" class="rc-pager__input" @keyup.enter="onJump" />
          <span>页</span>
        </span>
        <button class="rc-pager__ok" @click="onJump">确定</button>
      </div>
    </div>
    </div>
    <el-dialog
      :visible.sync="view_info_visible"
      width="70%"
      custom-class="rc-dialog">
      <template #title>
        <div class="rc-dialog__titlebox">
          <span class="rc-dialog__title">检测信息</span>
          <span class="rc-dialog__subtitle">{{ skuCheckInfo.task_no }}</span>
        </div>
      </template>
      <CheckLowerPrice :info="skuCheckInfo" ref="checkLowerPriceREF"></CheckLowerPrice>
      <template #footer>
        <el-button class="rc-dialog__close" @click="view_info_visible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions} from "vuex";

import CheckLowerPrice from "./checkLowerPrice.vue";
export default {
  components: {
    CheckLowerPrice
  },
  data() {
    return {
      view_info_visible:false,
      dataInfo:{},
      tableData:[],
      skuCheckInfo:{},
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
      pageSizeOptions: [10, 20, 50, 100, 200],
      jumpInput: 1,
      searchParams:{
        task_no:''
      },
      selectData:[],
      loading: false,
    }
  },
  created() {
    // this.initData()
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      opGetSkudetectionPage: 'ucenter/opGetSkudetectionPage',
    }),
    initData(){
      this.refresh()
    },
    refresh(){
      this.page_data.page = 1
      this.page_data.total = 0
      this.searchParams = {
        task_no:''
      }
      this.getDataList()
    },
    handleSearch(){
      this.page_data.page = 1
      this.getDataList()
    },
    onPageChange(page){
      this.page_data.page = page
      this.jumpInput = page
      this.getDataList()
    },
    onPageSizeChange(limit){
      this.page_data.limit = limit
      this.page_data.page = 1
      this.jumpInput = 1
      this.getDataList()
    },
    onJump(){
      const max = Math.max(1, Math.ceil(this.page_data.total / this.page_data.limit))
      const target = Math.min(Math.max(parseInt(this.jumpInput, 10) || 1, 1), max)
      this.jumpInput = target
      this.page_data.page = target
      this.getDataList()
    },
    selectChange(e){
      this.selectData = [...e]
    },
    //获取检测列表
    getDataList() {
      this.loading = true
      let param = {page_size:this.page_data.limit,page:this.page_data.page,...this.searchParams}
      this.opGetSkudetectionPage({
        data: param,
        success: (res) => {
          this.loading = false
          console.log(res)
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    view_info(row) {
      this.view_info_visible = true
      this.skuCheckInfo = row
    },
    view_abnormal(row) {
       //=== 查看 ===
       this.$emit('view-abnormal', row.task_no)
    }
  }
}
</script>


<style scoped>
.w_120{
  width: 150px;
}
.form-box{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 3px;
}

::v-deep(.el-form-item--small.el-form-item){
  margin-bottom: 0;
}
.opt-btn{
  height: 24px;
  padding: 0 8px;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  white-space: nowrap;
}
.opt-btn~.opt-btn{
  margin-left: 6px;
}
.opt-btn--blue {
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: var(--gx-cyan);
}
.opt-btn--blue:hover {
  color: #ffffff;
  background: var(--gx-cyan);
  border-color: var(--gx-cyan);
}
.opt-btn--red {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: var(--gx-red);
}
.opt-btn--red:hover {
  color: #ffffff;
  background: var(--gx-red);
  border-color: var(--gx-red);
}

::v-deep(.el-tag.el-tag--primary.el-tag--small.el-tag--light) {
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
}


/* ══ 表格列文字颜色（仅表体，不影响表头；show-overflow-tooltip 仍生效） ══ */
::v-deep(.el-table__body .rc-col-no .cell) {
    color: rgb(63, 182, 224);
}
::v-deep(.el-table__body .rc-col-red .cell) {
    color: rgb(200, 68, 60);
}

/* ══ 分页栏：左总数/每页条数 · 中页码 · 右跳转 ══ */
.rc-pager {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background: rgb(245, 240, 232);
    font-size: 13px;
    color: #606266;
}
.rc-pager__col {
    display: flex;
    align-items: center;
    gap: 8px;
}
.rc-pager__col--left { justify-content: flex-start; }
.rc-pager__col--center { justify-content: center; }
.rc-pager__col--right { justify-content: flex-end; }
.rc-pager__num {
    color: rgb(26, 26, 46);
    font-weight: 600;
}
.rc-pager__jump {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #606266;
}
.rc-pager__input {
    width: 36px;
    height: 24px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 0 6px;
    font-size: 13px;
    outline: none;
    color: #303133;
    text-align: center;
    background: #FFFFFF;
}
.rc-pager__input:focus { border-color: #f56c6c; }
.rc-pager__ok {
    height: 24px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid rgb(200, 68, 60);
    background: rgb(255, 245, 245);
    color: rgb(200, 68, 60);
    font-size: 12px;
    cursor: pointer;
    transition: background .15s;
}
.rc-pager__ok:hover {
    background: rgb(200, 68, 60);
    color: #FFFFFF;
}
/*.rc-pager ::v-deep(.el-pagination .el-pager li) {
    background: #f5f7fa;
    color: #606266;
    border: none;
    border-radius: 4px;
    margin: 0 2px;
    font-weight: 500;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
}
.rc-pager ::v-deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
    background: rgb(255, 245, 245);
    border: 1px solid rgb(200, 68, 60);
    color: rgb(200, 68, 60);
}
.rc-pager ::v-deep(.el-pagination .el-pager li:hover) {
    color: #f56c6c;
}
.rc-pager ::v-deep(.el-pagination .btn-prev),
.rc-pager ::v-deep(.el-pagination .btn-next) {
    background: #f5f7fa;
    color: #606266;
    border-radius: 4px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
}
.rc-pager ::v-deep(.el-pagination .btn-prev:hover),
.rc-pager ::v-deep(.el-pagination .btn-next:hover) {
    color: #f56c6c;
}*/
</style>

<!-- 检测信息弹窗（el-dialog 挂载在 body 下，需非 scoped 样式） -->
<style>
.rc-dialog {
    border-radius: 12px;
    overflow: hidden;
    background: #FFFFFF;
}
.rc-dialog .el-dialog__header {
    background: #F6EFE2;
    padding: 18px 20px 16px 24px;
    margin-right: 0;
    position: relative;
}
.rc-dialog .el-dialog__body {
    padding: 16px 20px;
    max-height: 68vh;
    overflow-y: auto;
}
.rc-dialog .el-dialog__footer {
    background: #F6EFE2;
    padding: 14px 20px 18px;
    text-align: right;
}
.rc-dialog__titlebox {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-left: 12px;
    border-left: 4px solid #D4A946;
}
.rc-dialog__title {
    font-size: 18px;
    font-weight: 700;
    color: #1A1A2E;
    line-height: 1.3;
}
.rc-dialog__subtitle {
    font-size: 13px;
    color: #8A8A9A;
    font-family: 'JetBrains Mono', monospace;
}
.rc-dialog .el-dialog__headerbtn {
    top: 18px;
    right: 20px;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #DCDFE6;
    border-radius: 6px;
    background: #FFFFFF;
    font-size: 16px;
}
.rc-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #909399;
    font-weight: 600;
}
.rc-dialog .el-dialog__headerbtn:hover {
    border-color: #C8443C;
}
.rc-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #C8443C;
}
.rc-dialog__close {
    background: linear-gradient(135deg, #D4A946, #E8C778);
    border: none;
    color: #FFFFFF;
    font-weight: 600;
    border-radius: 6px;
    padding: 9px 26px;
    box-shadow: 0 2px 8px rgba(212, 169, 70, .35);
}
.rc-dialog__close:hover,
.rc-dialog__close:focus {
    background: linear-gradient(135deg, #C99B3A, #E0BD6A);
    color: #FFFFFF;
}
</style>
